import React from 'react';

const WebAppContent = () => {
  return (
    <div id='webapp' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Proovi veebirakendust</h2>
        </div>
        <div className='row'>
          <div className='col-md-8 col-md-offset-2'>
            <div className='webapp-frame'>
              <iframe
                src="https://app.recyclemore.eu/"
                width="100%"
                height="600"
                style={{ border: 'none', borderRadius: '8px' }}
                title="RecycleMore Web App"
                allow="geolocation"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const WebApp = React.memo(WebAppContent);